const GroupEventFragment = `
    slug
    tags
    template {
      slug
    }
    featuredImageUrl
    priceInCents
    totalPriceInCents
    acceptsOnlinePayments
    paymentRecurrenceSchedule
    numberOfPayments
    lessonCount
    registrationCloseDateTime
    registrationOpenDateTime
    externalRegistrationUrl
    registrationCount
    maxAttendance
    collectAttendance
    sessions {
      id
      startDateTime
      endDateTime
      enrollments {
        id
        student {
          id
          firstName
          lastName
        }
        attended
        isCanceled
        transactions {
          amountInCents
          createdAt
          refund
          registrationPayment {
            id
          }
        }
      }
    }
    assistantCoaches {
      id
      name
    }
    waitlist {
      entries {
        contact {
          id
          externalId
          firstName
          lastName
          email
        }
      }
    }
    enrollments {
      rsvpStatus
    }
`
export default GroupEventFragment
